export const OpcoesResgate = [
    {
        Valor: "0", Nome: "0%"
    },
    {
        Valor: "1", Nome: "1%"
    },
    {
        Valor: "2", Nome: "2%"
    },
    {
        Valor: "3", Nome: "3%"
    },
    {
        Valor: "4", Nome: "4%"
    },
    {
        Valor: "5", Nome: "5%"
    },
    {
        Valor: "6", Nome: "6%"
    },
    {
        Valor: "7", Nome: "7%"
    },
    {
        Valor: "8", Nome: "8%"
    },
    {
        Valor: "9", Nome: "9%"
    },
    {
        Valor: "10", Nome: "10%"
    },
    {
        Valor: "11", Nome: "11%"
    },
    {
        Valor: "12", Nome: "12%"
    },
    {
        Valor: "13", Nome: "13%"
    },
    {
        Valor: "14", Nome: "14%"
    },
    {
        Valor: "15", Nome: "15%"
    },
    {
        Valor: "16", Nome: "16%"
    },
    {
        Valor: "17", Nome: "17%"
    },
    {
        Valor: "18", Nome: "18%"
    },
    {
        Valor: "19", Nome: "19%"
    },
    {
        Valor: "20", Nome: "20%"
    },
    {
        Valor: "21", Nome: "21%"
    },
    {
        Valor: "22", Nome: "22%"
    },
    {
        Valor: "23", Nome: "23%"
    },
    {
        Valor: "24", Nome: "24%"
    },
    {
        Valor: "25", Nome: "25%"
    }
];